import { z } from "zod";
import { createResponseSchema, paginationResponseSchema } from "../../../schemas/repository.schemas";
import { tableUpdateInfoSchema } from "../../../schemas/tableUpdate.schemas";
import { qaReviewKpiSchema } from "../../../schemas/qaReviewKpis.schemas";
import { financialReportChangesSchema } from '../../../schemas/financialReportChanges.schemas';

export const tableUpdateInfoListResponseSchema = createResponseSchema(paginationResponseSchema.extend({
    content: z.array(tableUpdateInfoSchema),
}));

export type TableUpdateInfoListResponseSchemaType = z.infer<typeof tableUpdateInfoListResponseSchema>;

// The find endpoint returns an unpaged collection (a bare array, not the wrapped
// {status, message, data} response) when no `page` param is supplied.
export const tableUpdateInfoCollectionSchema = z.array(tableUpdateInfoSchema);

export type TableUpdateInfoCollectionType = z.infer<typeof tableUpdateInfoCollectionSchema>;

export const qaReviewKpisResponseSchema = createResponseSchema(z.array(qaReviewKpiSchema));
export type QaReviewKpisResponseSchemaType = z.infer<typeof qaReviewKpisResponseSchema>;

// These legacy endpoints return their data directly, without a response wrapper.
export const appliedUpdateChangesResponseSchema = z.object({
    changesInPearReviewPhase: financialReportChangesSchema.nullish(),
    changesInQaReviewPhase: financialReportChangesSchema.nullish(),
    appliedChanges: financialReportChangesSchema.nullish(),
});

export type AppliedUpdateChangesResponseType = z.infer<typeof appliedUpdateChangesResponseSchema>;

export const archivedReviewChangesResponseSchema = z.object({
    mistakeChanges: financialReportChangesSchema.nullish(),
    remediationChanges: financialReportChangesSchema.nullish(),
});

export type ArchivedReviewChangesResponseType = z.infer<typeof archivedReviewChangesResponseSchema>;
